import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { FAQListItem } from "../../content.types";
import { requestReorderFaqItems } from "./reorderFaqItems.request";

const useReorderFaqItems = (
  options?: MutationOptions<{ data: FAQListItem[] }, ApiServiceError<ApiError>>
) => {
  const refetchFaqItems = useRefetchQuery(["content-faq"]);

  return useMutation({
    mutationFn: requestReorderFaqItems,
    ...options,
    // The widget reorders the cached list optimistically; resync with the
    // server only when the reorder fails.
    onError: (error, variables, context) => {
      void refetchFaqItems();
      options?.onError?.(error, variables, context);
    }
  });
};

export default useReorderFaqItems;
